import { render } from "./ContactsPaginationV2.vue?vue&type=template&id=2680d0c7&ts=true"
import script from "./ContactsPaginationV2.vue?vue&type=script&lang=ts"
export * from "./ContactsPaginationV2.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/qk/zz5x885n487_vn5fy4hxyvwh0000gn/T/deploy/contacts-ui/1a3855c3e2aea7b6a4fd4d74131a5b05d89c321c/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.37_vue@3.4.18_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__